/**
 * @generated SignedSource<<5a4c994a4459ddce4093806502476419>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAdminGroupDevices_store$data = {
  readonly id: string;
  readonly sharedMobileDevices: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly lastUsedAtDate: {
          readonly storeFormattedDate: string;
        } | null;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "UserAdminGroupDevices_store";
};
export type UserAdminGroupDevices_store$key = {
  readonly " $data"?: UserAdminGroupDevices_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAdminGroupDevices_store">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "sharedMobileDevices"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./UserAdminGroupDevicesPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserAdminGroupDevices_store",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "sharedMobileDevices",
      "args": null,
      "concreteType": "SharedMobileDeviceConnection",
      "kind": "LinkedField",
      "name": "__UserAdminGroupDevices_store_sharedMobileDevices_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SharedMobileDeviceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SharedMobileDevice",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "lastUsedAtDate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "style",
                          "value": "DATE_ONLY"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "storeFormattedDate",
                      "storageKey": "storeFormattedDate(style:\"DATE_ONLY\")"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "f73a53a7d9c11848e4b00cc93da86906";

export default node;
